import React from 'react';


export default function Heading({ no, children }) {
  return React.createElement(
    `h${no}`,
    null,
    children
  );
}